// import { Component } from "../../core/Component";
// import * as utils from "../../core/utils";

export class LoaderComponent {
  constructor(options) {
    this.boxId = `${options.formId}_loader_box`;
    this.rootId = `${options.formId}_loader_root`;
  }
  toHTML() {
    return `
    <section class="qform qform-loader-main" id="${this.rootId}">
      <div class="qform-loader qform-loader-open" id="${this.boxId}">
        <div class="qform-loader-box">
          <div class="qform-loader-box__dot"></div>
          <div class="qform-loader-box__dot"></div>
          <div class="qform-loader-box__dot"></div>
        </div>
      </div>
    </section>
    `;
  }
  init() {
    this.$box = document.querySelector(`#${this.boxId}`);
  }
}